import { useMemo } from 'react';
import { appcues } from '~/event-reporter/event-targets/appcues';
import { useGtm } from '~/event-reporter/event-targets/gtm';
import { heap } from '~/event-reporter/event-targets/heap';
import { hubspot } from '~/event-reporter/event-targets/hubspot';
export default function useEventTargets() {
    const gtm = useGtm();
    return useMemo(()=>({
            appcues,
            heap,
            hubspot,
            gtm
        }), []);
}
export function getMockEventTargets() {
    return {
        appcues: {
            identify: ()=>{},
            sendEventDeprecated: ()=>{},
            report: ()=>{},
            sendPageView: ()=>{}
        },
        heap: {
            resetIdentity: ()=>{},
            identify: ()=>{},
            sendEventDeprecated: ()=>{},
            report: ()=>{},
            addEventProperties: ()=>{}
        },
        hubspot: {
            resetIdentity: ()=>{},
            identify: ()=>{},
            sendEventDeprecated: ()=>{},
            report: ()=>{},
            sendPageView: ()=>{}
        },
        gtm: {
            sendEvent: ()=>{},
            sendEventDeprecated: ()=>{},
            report: ()=>{},
            sendPageView: ()=>{}
        }
    };
}
